import React, { useRef } from 'react';
import ReactDOM from "react-dom";
import { useStoreState } from "easy-peasy";

function Documentation() {
  const documentationUrl = useStoreState(state => state.selection.fan.documentationUrl);

  /* Reuse same ref on every render
   * https://github.com/facebook/react/issues/15110
   */
  const frameRef = useRef(null);

  if (!frameRef.current) {
    // Create and empty once
    frameRef.current = document.getElementById("docs");

    if (frameRef.current) {
      while (frameRef.current.firstChild) {
        frameRef.current.removeChild(frameRef.current.firstChild);
      }
    }
  }

  const domElement = frameRef.current;

  if (!domElement) {
    return <></>
  }

  return ReactDOM.createPortal(
    <turbo-frame id="documentation-frame" class="block w-full" loading="lazy" src={documentationUrl}>
      <div className="hide loader text-center progress-circle-indeterminate"></div>
    </turbo-frame>
    , domElement
  );
}

export default Documentation;
